<template>
  <div>
    <div class="pb-4">
      <PageHeader title="مدیریت بسته" :items="pageHeaderItems" />
    </div>
    <TabLink :items="links" />
    <div v-if="$route.fullPath !== '/list/packages/add' && !$route.params.packageId" class="card p-3">برای اضافه کردن این بخش ابتدا باید بسته را ثبت نمایید</div>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import appConfig from '@/app.config'
import TabLink from '../../../components/common/TabLink.vue'
import PageHeader from '../../../components/layoutComponents/page-header.vue'
export default {
  page: {
    title: 'مدیریت بسته',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-packages',
  components: {
    TabLink,
    PageHeader,
  },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت بسته', active: true },
      ],
    }
  },
  computed: {
    links() {
      if (this.$route.params.packageId !== undefined) {
        return [
          { title: 'ثبت بسته', link: this.$route.params.packageId ? `/list/packages/detail/${this.$route.params.packageId}` : '/list/packages/add' },
          { title: 'محتوا دوره', link: `/list/packages/${this.$route.params.packageId}/packagecourses` },
          // { title: 'سرفصل ها', link: this.$route.fullPath },
          { title: 'پیش نیاز', link: `/list/packages/${this.$route.params.packageId}/packageprerequisites` },
          { title: 'سوالات متداول', link: this.$route.params.packageId ? `/list/packages/questions/${this.$route.params.packageId}` : '/list/packages/questions' },
          { title: 'اعضا', link: `/list/packages/${this.$route.params.packageId}/users` },
          { title: 'نظرات', link: `/list/packages/${this.$route.params.packageId}/packagecomments` },
        ]
      }
      return [
        { title: 'ثبت بسته', link: '/list/packages/add' },
        { title: 'محتوا دوره', link: '#' },
        // { title: 'سرفصل ها', link: this.$route.fullPath },
        { title: 'پیش نیاز', link: '#' },
        { title: 'سوالات متداول', link: '#' },
        { title: 'اعضا', link: '#' },
        { title: 'نظرات', link: '#' },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .card {
  overflow-y: visible;
}

::v-deep .position-relative .list {
  height: 205px;
}
</style>
